/* tslint:disable */
/* eslint-disable */
export enum EventDeliveryStatusEnum {
  DeliverNotAttempted = 'DeliverNotAttempted',
  Delivered = 'Delivered',
  Failed = 'Failed'
}
